import React, { createContext, useContext } from "react";

const PlanContext = createContext({
  hasPlan: null,
  activePlan: null,
  hasFeature: () => false,
});

export function PlanProvider({ value, children }) {
  return <PlanContext.Provider value={value}>{children}</PlanContext.Provider>;
}

export function usePlan() {
  return useContext(PlanContext);
}
